import { render, staticRenderFns } from "./ConvModelliF24.vue?vue&type=template&id=f98687a0&scoped=true"
import script from "./ConvModelliF24.vue?vue&type=script&lang=js"
export * from "./ConvModelliF24.vue?vue&type=script&lang=js"
import style0 from "./ConvModelliF24.vue?vue&type=style&index=0&id=f98687a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98687a0",
  null
  
)

export default component.exports